<template>
  <div>
    <b-navbar sticky="true" type="light" variant="light">
		<div class="container">
			<b-navbar-brand to="/infection-outbreak-beta">感染爆发 Beta</b-navbar-brand>
			<b-navbar-nav class="ml-auto" small="true" >
				<!-- <b-nav-item to="#">概览</b-nav-item>
      			<b-nav-item to="#">如何使用</b-nav-item> -->
				<b-button rel="noopener" target="_blank" pill size="sm" variant="primary" @click="leaveFor" href="battlenet:://starcraft/map/5/61549" >前往战网游玩</b-button>
			</b-navbar-nav>
		</div>
    </b-navbar>

	<div class="card-container" >
    <div class="card-content" >
      <div class="description-container" style="text-align: center;" >
          <div>
            <h1>感染爆发 Beta</h1>
            <h3>一切的开始，我们的第一张地图</h3>
            <p>四名玩家共同抵御感染，一旦爆发，感染速度比你想象的要快，守好路口来抑制感染蔓延，单位死亡后会将他的枪口对准你，小心行事。
            </p>
            <PartnerAuthor></PartnerAuthor>
          </div>
			</div>
			<div class="img-container" >
				<img src="@/assets/SC_Map/Infection_Outbreak_Beta/enclosure.jpg" >
			</div>
	  </div>
  </div>

    <div class="card-container" >
      <div class="card-content" >
        <b-row no-gutters>
          <b-col sm="6">
            
            <div class="img-container" >
              <img src="@/assets/SC_Map/Infection_Outbreak_Beta/scv_be_attacked.jpg" >
            </div>
                
          </b-col>
          <b-col sm="6">
            
            <div class="description-container">
              <div>
                <h2>感染机制</h2>
                <h3>正是它，让游戏如此与众不同</h3>
                <p>稳步推进还是闪电攻势，这是个问题。每一次进攻都将面临这样的考验，过度损失单位会被自己反噬，这是何等的绝望。
                </p>
              </div>
            </div>
            
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="card-container" >
      <div class="card-content" >
        <b-row no-gutters>

          <b-col sm="6">
            
            <div class="description-container">
              <div>
                <h2>地图设计</h2>
                <h3>进可攻，退可守</h3>
                <p>稳步扩张，与队友分工防守，必要时收缩防线，又或者大举进攻，与此同时感染者还可能长驱直入。这大概是感染系列最棒的地图游戏性设计。
                </p>
              </div>
            </div>
            
          </b-col>

			<b-col sm="6">
				
				<div class="img-container" >
				<img src="@/assets/SC_Map/Infection_Outbreak_Beta/base_in_fire.jpg" >
				</div>
					
			</b-col>
        </b-row>
      </div>
    </div>
	

  </div>
</template>

<style lang="stylus" scoped>
	@import '~@/components/OverviewCard.styl'
</style>

<script>
import PartnerAuthor from '@/components/PartnerAuthor'
export default {
    methods: {
        leaveFor() {
            this.$ga.event('sc-map', 'battlenet', 'infection-outbreak-beta', 1)
            },
	},
  name: 'about',
    components: {
        PartnerAuthor
  }
}
</script>